import { findElementByIdInShadowDom } from './utils/render.js';
import { renderPrecinctMap } from './precinctMap';

const mapContainer = findElementByIdInShadowDom('map');

async function main() {
  renderPrecinctMap(mapContainer, 'city', {
    // A fixed path, so the build knows to include this file
    boundaryUrl: new URL(
      '../assets/data/boundaries/la-city.geojson',
      import.meta.url
    ),
    // PLACEHOLDER: mayor results until this race's file exists
    resultsUrl: new URL(
      '../assets/data/results/2026-general-la-mayor.json',
      import.meta.url
    ),
    // Neighborhood names to label the city map
    labelsUrl: new URL(
      '../assets/data/la-neighborhoods-points.geojson',
      import.meta.url
    ),
  });
}

main().catch(console.error);
